module.exports = __webpack_public_path__ + "img/snappay-gif-des.9689758e.gif";